import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MensIntimateWashBacterialVaginosisComponent } from '@components/consultation-request/upsells/mens-intimate-wash/bacterial-vaginosis/mens-intimate-wash-bacterial-vaginosis.component';
import { MensIntimateWashEdComponent } from '@components/consultation-request/upsells/mens-intimate-wash/ed/mens-intimate-wash-ed.component';
import { MensIntimateWashHsvComponent } from '@components/consultation-request/upsells/mens-intimate-wash/hsv/mens-intimate-wash-hsv.component';
import { MensIntimateWashMaleBvComponent } from '@components/consultation-request/upsells/mens-intimate-wash/male-bv/mens-intimate-wash-male-bv.component';
import { MensIntimateWashComponent } from '@components/consultation-request/upsells/mens-intimate-wash/mens-intimate-wash.component';
import { MensIntimateWashMetforminComponent } from '@components/consultation-request/upsells/mens-intimate-wash/metformin/mens-intimate-wash-metformin.component';
import { MensIntimateWashUtiComponent } from '@components/consultation-request/upsells/mens-intimate-wash/uti/mens-intimate-wash-uti.component';
import { MensIntimateWashYeastInfectionComponent } from '@components/consultation-request/upsells/mens-intimate-wash/yeast-infection/mens-intimate-wash-yeast-infection.component';
import { MensIntimateWashZofranComponent } from '@components/consultation-request/upsells/mens-intimate-wash/zofran/mens-intimate-wash-zofran.component';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { ConsultationStorageService } from '@services/consultation-storage.service';

/**
 * Switcher component that dynamically displays the appropriate Men's Intimate Wash upsell component based on the
 * consultation treatment type.
 */
@Component({
  selector: 'app-mens-intimate-wash-switcher',
  standalone: true,
  imports: [
    CommonModule,
    MensIntimateWashBacterialVaginosisComponent,
    MensIntimateWashComponent,
    MensIntimateWashEdComponent,
    MensIntimateWashHsvComponent,
    MensIntimateWashMaleBvComponent,
    MensIntimateWashMetforminComponent,
    MensIntimateWashUtiComponent,
    MensIntimateWashYeastInfectionComponent,
    MensIntimateWashZofranComponent,
  ],
  templateUrl: './mens-intimate-wash-switcher.component.html',
})
export class MensIntimateWashSwitcherComponent {
  public readonly ConsultationTreatmentTypes: typeof ConsultationTreatmentTypes = ConsultationTreatmentTypes;

  private consultationStorageService = inject(ConsultationStorageService);

  /**
   * Gets the current treatment type from the consultation storage service.
   */
  public get treatmentType(): ConsultationTreatmentTypes {
    return this.consultationStorageService.treatmentType;
  }
}
